import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Panel } from '../../../../../common/panel'
import { Table } from '../../../../../common/table'
import { expiryDate } from '../../../../../dashboard/components/currentPlan/helper'
import { formatText } from '../../../../../helpers/value'
import { CLASS_HIDE_TABLE_PDF } from '../../../../../utils/common'
import { COMPLETED_STATUS, PAYMENT_METHOD_PACKAGE } from '../../constants'
import { DateOrderedCell } from '../../table/DateOrderedCell'
import { OrderStatusCell } from '../../table/OrderStatusCell'
import {
  selectFactSheetCellData,
  selectFactSheetData,
  selectFactSheetIds,
  selectIsLoading,
} from '../store/slice'
import { CompanyName } from './table/CompanyName'
import { DownloadCell } from './table/DownloadCell'
import { FactSheetDescription } from './table/FactSheetDescription'
import { FileType } from './table/FileType'
import { LanguageCell } from './table/LanguageCell'
import { PriceCell } from './table/PriceCell'

const schema = {
  NO: {
    colId: 'id',
    title: '#',
  },
  COMPANY_NAME: {
    colId: 'organizationName',
    title: 'COMPANY_NAME',
  },
  TYPE: {
    colId: 'fiinGateReportTypeName',
    title: 'TYPE',
  },
  DESCRIPTION: {
    colId: 'availableData',
    title: 'DESCRIPTION',
  },
  LANGUAGE: {
    colId: 'languageCode',
    title: 'LANGUAGE',
  },
  CURRENCY: {
    colId: 'currencyCode',
    title: 'CURRENCY',
  },
  ADDITIONAL_CURRENCY: {
    colId: 'additionalCurrencyCode',
    title: 'ADDITIONAL_CURRENCY',
  },
  FILE_TYPE: {
    colId: 'fileType',
    title: 'FILE_TYPE',
  },
  DELIVERY_DATE: {
    colId: 'expectedDeliveryDate',
    title: 'DELIVERY_DATE',
  },
  STATUS: {
    colId: 'status',
    title: 'ORDER_STATUS',
  },
  PRICE: {
    colId: 'priceVND',
    title: 'PRICE',
  },
  REPORT: {
    colId: 'orderDetailId',
    title: 'REPORT',
  },
}

export const FactSheet = ({ isPdf = false }) => {
  const ids = useSelector(selectFactSheetIds)
  const isLoading = useSelector(selectIsLoading)
  const factSheetData = useSelector(selectFactSheetData)

  const renderContent = () => {
    return (
      !!ids.length && (
        <div className="mt2">
          <Element
            className={`${CLASS_HIDE_TABLE_PDF}`}
            style={{
              color: '#0553A5',
              fontSize: 14,
              fontWeight: 600,
              padding: '0px 12px',
              paddingTop: isPdf ? 12 : 0,
            }}
          >
            FiinGate Factsheet
          </Element>
          <Table
            ids={ids}
            isNoDataWithHead
            isLoading={isLoading}
            getDataFromRedux={selectFactSheetCellData}
            isDisplayScroll={false}
            isNoStickyHead={isPdf}
            schema={Object.keys(schema)
              .filter((key) => !isPdf || key !== 'REPORT')
              .map((key) => {
                const result = {
                  colId: schema[key].colId,
                  title:
                    'userManagement.orderManagement.orderDetail.' +
                    schema[key].title,
                  isI18n: true,
                  isHtml: true,
                  thStyle: { textAlign: 'left' },
                  render: (val, { locale, rowId }) => {
                    switch (schema[key].colId) {
                      case schema.COMPANY_NAME.colId:
                        return (
                          <CompanyName
                            val={val}
                            rowId={rowId}
                            getDataFromRedux={selectFactSheetCellData}
                          />
                        )
                      case schema.DESCRIPTION.colId:
                        return (
                          <FactSheetDescription
                            val={val}
                            rowId={rowId}
                            getDataFromRedux={selectFactSheetCellData}
                          />
                        )
                      case schema.LANGUAGE.colId:
                        return <LanguageCell val={val} />
                      case schema.DELIVERY_DATE.colId:
                        return <DateOrderedCell val={val} locale={locale} />
                      case schema.REPORT.colId:
                        const isNotCompletedStatus =
                          factSheetData[rowId - 1]?.status !== COMPLETED_STATUS
                        const isExpired =
                          expiryDate(factSheetData[rowId - 1]?.expiryDate) <= 0
                        return (
                          <DownloadCell
                            val={val}
                            isDisabled={isNotCompletedStatus}
                            isExpired={isExpired}
                          />
                        )
                      case schema.STATUS.colId:
                        return <OrderStatusCell val={val} />
                      case schema.PRICE.colId:
                        return (
                          <>
                            {factSheetData[rowId - 1]?.paymentMethod ===
                            PAYMENT_METHOD_PACKAGE ? (
                              <></>
                            ) : (
                              <PriceCell
                                val={val}
                                rowId={rowId}
                                getDataFromRedux={selectFactSheetCellData}
                              />
                            )}
                          </>
                        )
                      case schema.FILE_TYPE.colId:
                        return <FileType fileType={val} />
                      default:
                        return formatText(val)
                    }
                  },
                }

                return result
              })}
          />
        </div>
      )
    )
  }

  if (isPdf) {
    return (
      <Panel
        label="userManagement.orderManagement.orderDetail.ORDER_DETAILS"
        isI18n
      >
        {renderContent()}
      </Panel>
    )
  }

  return <>{renderContent()}</>
}
